import React from "react";

export default function JobList({ list, onClear }) {
  if (list.length === 0) return null;

  return (
    <div className="mt-4 space-y-2">
      <ul className="list-none p-0 space-y-2">
        {list.map(({ id, title, achieved, status, thumbnail, artist }) => (
          <li
            key={id}
            className="flex items-center bg-secondary rounded-lg p-3 animate-slide-up"
          >
            {/* Thumbnail with Progress */}
            <div className="flex-shrink-0 relative">
              <div
                className="w-14 h-14 md:w-16 md:h-16 bg-cover bg-center rounded-lg"
                style={{ backgroundImage: `url(${thumbnail})` }}
              >
                {/* Progress Bar */}
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-80 rounded-b-lg p-1">
                  <div className="h-1 bg-gray-400 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-accent transition-all duration-1000 ease-out"
                      style={{ width: `${achieved}%` }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Job Details */}
            <div className="flex-1 ml-3 min-w-0">
              <p className="text-text text-sm md:text-base font-medium truncate m-0">
                {title} - {artist}
              </p>
              <p className="text-gray-400 text-xs md:text-sm m-0 mt-1">
                Status: {status}
                {status !== "DONE" && (
                  <span className="ml-2 text-accent">({achieved}%)</span>
                )}
              </p>
            </div>

            {/* Status Icon */}
            <div className="flex-shrink-0 ml-2">
              {status === "DONE" ? (
                <span className="text-green-500 text-xl">✓</span>
              ) : (
                <span className="text-accent text-xl animate-spin-slow">⟳</span>
              )}
            </div>
          </li>
        ))}
      </ul>

      {/* Clear Jobs Button */}
      {list.length > 0 && (
        <button
          onClick={() => onClear()}
          className="w-full text-center text-gray-400 hover:text-text py-2 text-sm transition-colors cursor-pointer"
        >
          ─────── Clear Jobs ───────
        </button>
      )}
    </div>
  );
}
